import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { API_HIERARCHYMODULE, API_PARAMETERHIERARCHY } from '../../../commons/api';
import { DrawerFooter } from '../../../commons/styles/layout';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Form,
  Col,
  Input,
  Drawer,
  Button,
  Row,
  message,
  Popconfirm,
  Tree,
  Select,
  Checkbox,
} from 'antd';

const { TreeNode } = Tree;
const { Option } = Select;

const Hierarchy = (props) => {
  const [visible, setVisible] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [treeData, setTreeData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [checked, setChecked] = useState(false);
  const [treeObject, setTreeObject] = useState([]);
  const hRef = useRef(null);

  useEffect(() => {
    _getHierarchyList();
  }, []);

  const _getHierarchyList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.MainHierarchyList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setDatasource(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openModal = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setVisible(true);
    setEditObj({});
  };

  const _cancel = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
    setChecked(false);
    setCheckedKeys([]);
  };

  const editHierarchy = (editObj) => {
    if (hRef.current) {
      hRef.current.setFieldsValue(editObj);
    }
    setEditObj(editObj);
    setVisible(true);
  };

  const checkboxChange = (value) =>{
    setTreeObject([]);
    setChecked(value);
     if (hRef.current) {
      hRef.current.setFieldsValue({
        ReplicateHierarchyCode:null,
      });
    }
    setEditObj((prevState)=>({
      ...prevState,
        ReplicateHierarchyCode:null
    }));
  };

  const _createHierarchy = () => {
    hRef.current
      .validateFields()
      .then(async (values) => {
        if (checked === true && checkedKeys.length !== 0) {
          let payload = {
            ...values,
            HierarchyIdNodes: checkedKeys,
            ParameterHierarchy:true
          };
          _createHierarchyFromHierarchyAPI(payload);
        } else {
          _createHierarchyAPI(values);
        }
      })
      .catch(() => { });
  };

  const _createHierarchyFromHierarchyAPI = (createObject) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let orgCreateHeaders = {
      method: 'POST',
      url: `${API_HIERARCHYMODULE.CreateVirtualHierarchies}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...createObject, SiteId: siteId }
    };
    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success('Hierarchy Saved');
          _getHierarchyList();
          setVisible(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.error(err.response.data.message);
        }
      });
  };

  const _updateHierarchy = () => {
    hRef.current
      .validateFields()
      .then(async (values) => {
        let updateObject = {
          ...values,
          Id: editObj.Id
        };
        _updateHierarchyAPI(updateObject);
      })
      .catch(() => { });
  };

  const _createHierarchyAPI = (createObject) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let orgCreateHeaders = {
      method: 'POST',
      url: `${API_HIERARCHYMODULE.MainHierarchyCreate}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...createObject , SiteId: siteId }
    };
    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success('Hierarchy Saved');
          _getHierarchyList();
          setVisible(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.error(err.response.data.message);
        }
      });
  };

  const _updateHierarchyAPI = (updateObject) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let orgUpdateHeaders = {
      method: 'PATCH',
      url: `${API_HIERARCHYMODULE.MainHierarchyUpdate}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(orgUpdateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success('Hierarchy Updated');
          _getHierarchyList();
          setVisible(false);
          setEditObj({});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _deleteHierarchy = (payload) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let orgDeleteHeaders = {
      method: 'POST',
      url: `${API_HIERARCHYMODULE.MainHierarchyDelete}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('Hierarchy Deleted');
          _getHierarchyList();
          setVisible(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.error(err.response.data.message);
        }
      });
  };

  const openHierarchyForm = (record) => {
    props.navigate(`/rubus/settingsPage/ParameterHierarchy/${record.HierarchyCode}`);
  };

  const onViewHierarchy = async (record) => {
    let treeData = await _getHierarchyLevels(record.HierarchyCode);
    setTreeData(treeData);
    setModalVisible(true);
  };

  const onGetHierarchy = async (record) => {
    let treeObject = await _getHierarchyLevels(record);
    setTreeObject(treeObject);
  };

  const _getHierarchyLevels = (record) => {
    
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let headers = {
      method: 'GET',
      url: `${API_PARAMETERHIERARCHY.VIEW}?SiteId=${siteId}&HierarchyCode=${record}&ParentId=null`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(headers)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderTreeNodes = (data) =>
    data &&
    Array.isArray(data) &&
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.Name} key={item.Id} autoExpandParent={true} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.Id} title={item.Name} {...item} />;
    });

  const onClose = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setModalVisible(false);
    setEditObj({});
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const columns = [
    {
      title: translation('Hierarchy Name'),
      dataIndex: 'HierarchyName'
    },
    {
      title: translation('Hierarchy Code'),
      dataIndex: 'HierarchyCode'
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            onClick={() => editHierarchy(record)}
            style={{ marginRight: '10px' }}
          >
            <EditOutlined />
          </Button>

          {record && record.Default && record.Default !== true ? (
            <Popconfirm title={translation('Are you sure delete Hierarchy?')}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteHierarchy(record);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Button
                type="primary"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          ) : null}

          <Button
            type="primary"
            onClick={() => openHierarchyForm(record)}
            style={{ marginLeft: '10px' }}
          >
            {translation('Click to redirect')}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: '10px' }}
            onClick={() => onViewHierarchy(record)}
          >
            {translation('View')}
          </Button>
        </div>
      )
    }
  ];

  return (
    <>
      <Drawer open={modalVisible} closable onClose={onClose} width={600}>
        <Tree defaultExpandAll={true} showLine>
          {treeData && Array.isArray(treeData) && treeData.length !== 0 ? renderTreeNodes(treeData) : null}
        </Tree>
      </Drawer>
      <Drawer
        title={!editObj.Id ? translation('Create Hierarchy') : translation('Update Hierarchy')}
        open={visible}
        width={600}
        closable
        onClose={_cancel}
      >
        <Form
          layout="vertical"
          name={'HierarchyForm'}
          ref={hRef}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={translation('Hierarchy Name')} name="HierarchyName"
              rules={[
                      { required: true, message: translation("Please Enter Hierarchy Name") }
                    ]}
              >
                <Input placeholder={translation('Please enter Hierarchy name')} />
              </Form.Item>

              <Form.Item label={translation('Hierarchy Code')} name="HierarchyCode"
              rules={[
                      { required: true, message: translation("Please Enter Hierarchy Code") }
                    ]}
              >
                <Input placeholder={translation('Please enter Hierarchy Code')} disabled={!editObj.Id ? false:true} />
              </Form.Item>
              {!editObj.Id ? (
                <>
                  <Checkbox
                    style={{ marginBottom: '20px' }}
                    checked={checked}
                    onChange={(e) => checkboxChange(e.target.checked)}
                  >
                    {translation('Click to choose hierarchy from existing tree structure')}
                  </Checkbox>
                  {checked === true ? (
                    <>
                      <Form.Item
                        label={translation('Replicate Hierarchy')}
                        name="ReplicateHierarchyCode"
                      >
                        <Select
                          onChange={(e) => onGetHierarchy(e)}
                          placeholder={translation('Replicate Hierarchy')}
                        >
                          {datasource && Array.isArray(datasource)
                            ? datasource.map((hierarchy, index) => (
                              <Option key={index} value={hierarchy.HierarchyCode}>
                                {translation(hierarchy.HierarchyName)}
                              </Option>
                            ))
                            : null}
                        </Select>
                      </Form.Item>

                      <Form.Item label={'Select Tree'}>
                        <Tree
                          defaultExpandAll={true}
                          checkable
                          onCheck={(e) => setCheckedKeys(e)}
                          checkedKeys={checkedKeys}
                        >
                          {treeObject && Array.isArray(treeObject) ? renderTreeNodes(treeObject) : null}
                        </Tree>
                      </Form.Item>
                    </>
                  ) : null}
                </>
              ) : null}
            </Col>
          </Row>
        </Form>
        <DrawerFooter>
          <Button onClick={_cancel} type='primary' style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {!editObj.Id ? (
            <Button type="primary" onClick={() => _createHierarchy()}>
              {translation('Create')}
            </Button>
          ) : (
            <Button type="primary" onClick={() => _updateHierarchy()}>
              {translation('Update')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        style={{ marginBottom: '10px' }}
        onClick={openModal}
      >
        {translation('Add')}
      </Button>
      <StyledTable size="small"
        columns={columns}
        dataSource={datasource}
        pagination={
          datasource.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(Hierarchy);